import { createFileRoute } from "@tanstack/react-router";
import CultivationFetch from "../../app/views/cultivation/cultivationFetch";

const CultivationFetchComponent = () => (
  <CultivationFetch cultivationType="lungmask" />
);

export const Route = createFileRoute("/lungmask/fetch")({
  component: CultivationFetchComponent,
});
